import { render, staticRenderFns } from "./pdfjs.vue?vue&type=template&id=35c3707c&scoped=true&"
import script from "./pdfjs.vue?vue&type=script&lang=js&"
export * from "./pdfjs.vue?vue&type=script&lang=js&"
import style0 from "./pdfjs.vue?vue&type=style&index=0&id=35c3707c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c3707c",
  null
  
)

export default component.exports